window.ErrorHandler || (window.ErrorHandler = {})

ErrorHandler.alertError = function (errorText, options) {
  let msg
  if (typeof errorText === 'string') {
    msg = [errorText]
    if (options && options.addOn) {
      msg.push(options.addOn)
    }
    return $.growlyflash({
      msg,
      type: 'danger'
    }, options)
  }
}

ErrorHandler.handleInvalidAuthenticityToken = function (response) {
  // if (response.getResponseHeader('Exception-Name') !== 'InvalidAuthenticityToken') {
  //   return;
  // }
  // return window.location.href = response.responseJSON.url;
}

ErrorHandler.handleAnyAjaxError = function (event, response) {
  // var error;
  // if (response.status || response.responseText) {
  //   console.log("Got ajaxError " + (response.status || null) + ", response:, " + (response.responseText || null));
  //   ErrorHandler.handleInvalidAuthenticityToken(response);
  //   error = response.error || (response && response.responseJSON && response.responseJSON.error);
  //   if (error) {
  //     return ErrorHandler.alertError(error);
  //   }
  // }
}
